module.exports = __webpack_public_path__ + "img/2-7-aria.ab7d4c23.jpg";